module.exports = __webpack_public_path__ + "img/user-gear.c5df740a.svg";